export const addressCompleted = () => ({
  type: 'Address Completed',
});

export const phoneNumberCompleted = () => ({
  type: 'Phone Number Completed',
});

export const smsUpdateToggled = state => ({
  type: 'SMS Updates Toggled',
  data: { state },
});
